import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-my-lib',
  template: `
    <p>
     {{inputData}}
    </p>
  `,
  styles: [
  ]
})
export class MyLibComponent implements OnInit {
@Input() inputData:any;
  constructor() { }

  ngOnInit(): void {
    console.log(this.inputData);
  }

}
